import { Flex, Icon, useAppTheme } from '@workwhile/ui'
import { ColorVariant } from '@workwhile/ui/dist/colors'
import { LucideIcon } from 'lucide-react'
import React from 'react'
import styled from 'styled-components'

export const IconContainer = styled(Flex).attrs({
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: '50%',
  padding: 2,
  width: 36,
  height: 36,
  style: (props) => ({ color: props.color }),
})`
  cursor: pointer;
  &:hover {
    background-color: ${({ theme }) => theme.colors.primary50};
    color: ${({ theme }) => theme.colors.primary300};
  }
`

type ActionIconProps = {
  icon: LucideIcon
  title: string
  onClick: () => void
  color?: ColorVariant
}

export const ActionIcon = ({
  icon,
  title,
  onClick,
  color = 'primary',
}: ActionIconProps) => {
  const { colors } = useAppTheme()
  const iconColor = colors[color]

  return (
    <IconContainer title={title} onClick={onClick} color={iconColor}>
      <Icon icon={icon} size={18} />
    </IconContainer>
  )
}
